import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import usePrepTeamRequestContext from 'contexts/kitchen/prep-team-request.context/context';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';
import ItemListView from './item-list-view';
import SendItemsForm from './send-items-form';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const UpdateKitchenRequest = () => {
  const { itemRequestToEdit, setItemRequestToEdit } = usePrepTeamRequestContext();
  const [step, setStep] = useState(1);
  const [selectedItemId, setSelectedItemId] = useState('');
  const [currentStatus, setCurrentStatus] = useState(itemRequestToEdit?.status);
  const navigate = useNavigate();
  const { can } = useRoleContext();
  const canWriteKitchenRequisition = can(InventoryModule.KitchenRequisition, RolePermission.Write);

  useEffect(() => {
    if (!itemRequestToEdit || !itemRequestToEdit.id) {
      navigate(MAIN_STORE_ROUTE_KEYS.PREP_REQUESTS, { replace: true });
    }
  }, [itemRequestToEdit, navigate]);

  if (!itemRequestToEdit || !itemRequestToEdit.id) {
    return null;
  }
  const handleSendItems = (itemId: string) => {
    if (!canWriteKitchenRequisition) return;
    setSelectedItemId(itemId);
    setStep(2);
  };

  const handleSuccess = () => {
    const newStatus = ENUM_REQUEST_STATUS.SENT;
    setItemRequestToEdit((prev) => ({
      ...prev,
      status: newStatus
    }));
    setCurrentStatus(newStatus);
    setStep(1);
  };

  const handleCancel = () => {
    if (step === 1) {
      navigate(-1);
    } else {
      setSelectedItemId('');
      setStep(1);
    }
  };

  return (
    <RequestDetailsWrapper
      codeId={itemRequestToEdit.code}
      status={currentStatus || itemRequestToEdit?.status}
      header={step === 1 ? 'Review and send Items' : 'Send Items'}
      subHeader={
        step === 1
          ? 'Update item as received or returned once vendor delivers'
          : 'Confirm batch details'
      }
      pageTitle='Track progress with procurement'
      backLinkTitle='Return to procurement'>
      {step === 1 && <ItemListView onSendItems={handleSendItems} />}

      {step === 2 && (
        <SendItemsForm
          selectedItemId={selectedItemId}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      )}
    </RequestDetailsWrapper>
  );
};

export default UpdateKitchenRequest;
